module.exports = __webpack_public_path__ + "static/media/scan-here.49521226.svg";